export function getState(state) {
  return state;
}
